import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../layouts/Layout';
import SEO from '../components/SEO';
import Jumbotron from '../components/Home/Jumbotron';
import ModulesRSE from '../components/Home/ModulesRSE';
import DigitalLearning from '../components/Home/DigitalLearning';
import Solutions from '../components/Home/Solutions';
import SurMesure from '../components/Home/SurMesure';
import LMS from '../components/Home/Lms';
import Clients from '../components/Home/Clients';
import Newsletter from '../components/Home/Newsletter';

export default function Home({ location, data }) {
	const page = data.allMdx.edges.find(
		({
			node: {
				fields: { block },
			},
		}) => block === null,
	).node;

	const blocks = data.allMdx.edges.reduce(
		(
			acc,
			{
				node: {
					id,
					body,
					frontmatter,
					fields: { block },
				},
			},
		) => {
			return {
				...acc,
				[block]: {
					id,
					body,
					frontmatter,
				},
			};
		},
		{},
	);

	const metaTitle = page.frontmatter.title;
	const metaDescription = page.frontmatter.description;

	return (
		<Layout className="page-home">
			<SEO
				pathname={location.pathname}
				title={metaTitle}
				description={metaDescription}
			/>
			<div className="screen screen-home">
				<Jumbotron />
				<ModulesRSE
					blocks={blocks}
					className="section-block modules-rse"
				></ModulesRSE>
				<DigitalLearning blocks={blocks}></DigitalLearning>
				<Solutions blocks={blocks}></Solutions>
				<SurMesure blocks={blocks}></SurMesure>
				<LMS blocks={blocks}></LMS>
				<Clients />
				<Newsletter />
			</div>
		</Layout>
	);
}

export const query = graphql`
	query {
		allMdx(
			filter: {
				fields: { collection: { eq: "pages" }, page: { eq: "home" } }
			}
		) {
			edges {
				node {
					id
					body
					fields {
						collection
						page
						block
					}
					frontmatter {
						title
						description
						linkURL
						linkTitle
					}
				}
			}
		}
	}
`;
